/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Landing_Calendar_CountInputs */

const en_landing_calendar_count = /** @type {(inputs: Landing_Calendar_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} coaches with open times`)
};

const pl_landing_calendar_count = /** @type {(inputs: Landing_Calendar_CountInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count} trenerów z wolnymi terminami`)
};

/**
* | output |
* | --- |
* | "{count} coaches with open times" |
*
* @param {Landing_Calendar_CountInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const landing_calendar_count = /** @type {((inputs: Landing_Calendar_CountInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Calendar_CountInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_landing_calendar_count(inputs)
	return en_landing_calendar_count(inputs)
});